module.exports = __webpack_public_path__ + "static/media/tournaments-menu-icon.27485bcb.svg";